<script setup>
    import { ref } from "vue";
    import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
    import { Link, Head } from '@inertiajs/inertia-vue3';
    import BaseButton from "@/Components/BaseButton.vue";
    import { mdiPlusCircle } from "@mdi/js";
    import CardBox from "@/Components/CardBox.vue";
    import TableAdvanced from "@/Components/TableAdvanced.vue";
    import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
    defineProps({
        datalist: Array,
        columnas: Array
    });

    const rutaPrefijo = ref('user');
</script>

<template>
    <Head title="Usuarios" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Usuarios <!-- In basebutton: @click="route('dashboard')"-->
                <Link :href="route(rutaPrefijo+'-create')">
                    <BaseButton
                        color="info"
                        :icon="mdiPlusCircle"
                        small
                        label=" Nuevo"
                        class="ml-8 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                    />
                </Link>
            </h2>   
        </template>

        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                        
                        <!-- <CardBox v-if="users.length" class="mb-6" has-table>
                            <TableAdvance :data="users" />
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
 -->
                        <CardBox v-if="datalist.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced modulo="user" modulos="Usuarios" :data="datalist" :fields="columnas" :ruta="rutaPrefijo"/>
                            </div>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
